










import {Component, Prop} from 'vue-property-decorator';
import CommonVue from '@/models/commonVue';
import Exercise from "@/api/exercise";

@Component({
})
export default class JsonView extends CommonVue {
    @Prop({type: Number}) public id?: number;

    public exerciseJson?: any = null;

    public async beforeMount() {
        await this.load();
    }

    public async load() {
        await this.loadExercise();
    }

    public async loadExercise(): Promise<void> {
        this.exerciseJson = await Exercise.getJson(this.id);
    }

    public syntaxHighlight(json: any) {
        if (typeof json != 'string') {
             json = JSON.stringify(json, undefined, 2);
        }
        json = json.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
        return json.replace(/("(\\u[a-zA-Z0-9]{4}|\\[^u]|[^\\"])*"(\s*:)?|\b(true|false|null)\b|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?)/g, function (match) {
            let cls = 'number';
            if (/^"/.test(match)) {
                if (/:$/.test(match)) {
                    cls = 'key';
                } else {
                    cls = 'string';
                }
            } else if (/true|false/.test(match)) {
                cls = 'boolean';
            } else if (/null/.test(match)) {
                cls = 'null';
            }
            return '<span class="' + cls + '">' + match + '</span>';
        });
    }
}
